































import { Component, Vue } from 'vue-property-decorator';
import { RealmApi } from '@/services/api/api.realms';
import { ApiPermissions } from '@/core/security/Permissions';
import ProgressBar from '@/components/ProgressBar.vue';
import bus from '@/core/bus';
import { BusConstants, ModalConstants } from '@/core/constants';
import { RealmLogType } from '@/types/apiServerContract';
import { AxiosProgressEvent } from 'axios';

@Component({
    components: { ProgressBar }
})
export default class UploadPatch extends Vue {
	permissions: string[] = [ApiPermissions.Realm.UploadPatch];

	file: any;
    loadPercentage: number = 0;
    kbps: number = 0;
    serverProcessing: string = '';

    formatBytes(kbytes: number, decimals = 2) {
	    if (kbytes === 0) return '0 Kb/s';

        const unit = kbytes > 1024 ? 'Mb/s' : 'Kb/s';
        const speed = (kbytes > 1024 ? kbytes / 1024 : kbytes).toFixed(2);
        return speed + ' ' + unit;
    }

	public $refs!: {
		file: HTMLInputElement;
	};

	async HandleUploadFile(files: any[], callback: () => void) {
	    this.serverProcessing = '';
	    this.kbps = 0;

	    const calculateUploadSpeed = (e1: AxiosProgressEvent, e2: AxiosProgressEvent) => {
	        const timeElapsed = ((e1.event?.timeStamp ?? 0) - (e2.event?.timeStamp ?? 0));

	        const bytes = e1.loaded;
	        const kbytes = bytes / 1024;

	        const lastbytes = e2.loaded;
	        const lastkbytes = lastbytes / 1024;

	        const uploadedKbytes = kbytes - lastkbytes;

	        const elapsed = timeElapsed / 1000;
	        const kbps = elapsed ? uploadedKbytes / elapsed : 0;

	        return kbps;
	    };

	    let e1: AxiosProgressEvent;
	    let e2: AxiosProgressEvent;

	    const result = await RealmApi.UploadPatch(files, event => {
	        this.loadPercentage = Math.round((event.loaded * 100) / event.total);

	        e2 = e1;
	        e1 = event;

	        if (e1 && e2) {
	            this.kbps = calculateUploadSpeed(e1, e2);
	        }

	        if (event.loaded === event.total) {
	            this.serverProcessing = 'Server is processing the file(s)...';
	            this.kbps = 0;
	        }
	    });

	    if (!result.data) return;

	    this.$bvToast.toast('Patch(s) uploaded successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.serverProcessing = 'Upload successfull';

	    callback();
	}

	showHistory() {
	    bus.emit(BusConstants.RealmLogHistoryType, RealmLogType.PatchUpload);
	    this.$bvModal.show(ModalConstants.RealmLogHistoryWindow);
	}
}
